<template>
  <div class="tab-bar">
    <div
      v-for="item in list"
      :key="item.value"
      :class="{ active: value === item.value }"
      class="tab-item"
      @click="clickTab(item)"
    >
      <span class="tab-txt">{{ item.label }}</span>
    </div>
  </div>
</template>

<script>
  /**
 * tabs 标签
 * @description tabs标签组件
 * @property {Array} list 标签数组，元素为对象，如[{ label: '工艺流程图', value: 'flowChart' }]
 * @property {String Number} value v-model双向绑定哪个tab为激活状态
 * @event {Function} change 点击标签时触发
 * @example ```html
              <TabBar :list="tabList" v-model="selectTab"></TabBar>
            ```
 */
  export default {
    name: "TabBar",
    model: {
      prop: "value",
      event: "change",
    },
    props: {
      value: { type: [Number, String], required: true },
      list: { type: Array, default: () => [] },
    },
    methods: {
      /** 点击Tab */
      clickTab({ value }) {
        if (this.value === value) {
          return;
        }
        this.$emit("change", value);
      },
    },
  };
</script>

<style scoped lang="less">
  .tab-bar {
    box-sizing: border-box;
    display: flex;
    height: 24px;

    .tab-item {
      box-sizing: border-box;
      display: flex;
      align-items: center;
      justify-content: center;
      min-width: 45px;
      height: 100%;
      padding: 2px;
      font-size: 12px;
      color: rgba(0, 178, 255, 0.5);
      border: 1px solid #00b2ff;
      border-left-width: 0;
      white-space: nowrap;
      user-select: none;
      cursor: pointer;

      &:first-child {
        border-left-width: 1px;
      }

      &.active {
        color: #00b2ff;
        background: #002d41;
        box-shadow: inset 0px 0px 7px 0px #00b2ff;
      }
    }
  }
</style>
